import React from "react";

import PropTypes from 'prop-types';

const MoreOptionsDropdownMenu = React.forwardRef(
    ({ children }, ref) => {
      
      return (
        <div
          ref={ref}
          className={"ps-more-options-menu"}
        >
    
          <ul className="ps-more-options-menu">
            {React.Children.toArray(children).filter(
              child =>
                    <div>{child.props}</div>
            )}
          </ul>
        </div>
      );
    },
);
  
MoreOptionsDropdownMenu.displayName = "MoreOptionsDropdownMenu";

MoreOptionsDropdownMenu.propTypes = {
    children: PropTypes.element
  };

export default MoreOptionsDropdownMenu;